import React from "react";

const promotions = [
  {
    img: "/r1.jpg",
    alt: "NBK popcorn offer",
  },
  {
    img: "/r2.jpg",
    alt: "Buy one get one NBK",
  },
  {
    img: "/r3.jpg",
    alt: "Mad Monday",
  },
];

const PromotionsPage = () => {
  return (
    <div className="max-w-screen-xl mx-auto px-6 py-6">
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-3xl font-semibold">EVENTS & PROMOTIONS</h2>
        <a href="#" className="text-sm font-medium text-black hover:underline">
          VIEW ALL
        </a>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {promotions.map((promo, i) => (
          <div
            key={i}
            className="overflow-hidden rounded-xl bg-white shadow-md hover:scale-105 transition-transform duration-300 cursor-pointer"
          >
            <img
              src={promo.img}
              alt={promo.alt}
              className="w-full h-auto object-cover"
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default PromotionsPage;
